module.exports = __webpack_public_path__ + "static/media/3.767f0bbb.jpg";